import React from 'react';
import ReactDOM from 'react-dom';
import PickerWidget from '../../components/builder/PickerWidget.js';
import OptionColumn from '../../components/general/OptionColumn.js';

export default class Step1 extends React.Component {
	constructor(props) {
		super(props);


	}



	render() {	
		return (
			<OptionColumn title="Goal" description={`What is your goal with this ${(this.props.router.params.type == 'email' ? 'email':'popup')}`}>
				<ul className="list-group list-group-full">
				{this.props.categories.map((c) => {
            		return <PickerWidget 
            			key={c.id}
                		heading={c.title} 
                		description={c.description}
                		image={c.image}
                		item={c.id}
                		onSelect={this.props.onSelect}
                	/>
            	})}
            	</ul>
			</OptionColumn>
		);
	}
}




// WEBPACK FOOTER //
// ./containers/picker/step1.js